import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';

import DashboardWidgets from '../../features/dashboard-v1/DashboardWidgets';
import TabsNav from '../3modules/Tabs/TabsNav/TabsNav';
import TabHeader from '../3modules/Tabs/TabHeader';

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: 60,
    height: '100%',
    paddingTop: 18,
    paddingLeft: 12,
    paddingBottom: 13,
    paddingRight: 11,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  mobileRoot: {
    height: 'inherit',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    paddingLeft: 4,
    position: 'relative',
    top: '-24px'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: 5,
    position: 'relative',
    justifyContent: 'space-between',
    width: '100%'
  },
  menuBar: {
    display: 'flex',
    marginLeft: '-10px'
  },
  widgets: {
    width: 'max-content'
  },
  widgetsDiv: {
    flexShrink: 0,
    marginLeft: 'auto',
    marginRight: '20px',
    position: 'relative',
  },
  backIconWrapper: {
    paddingRight: '20px'
  }
}));

export default function FullView({ children, disabled, className }) {
  const colorSelect = localStorage.getItem('colorSelect');
  const classes = useStyles({ colorSelect });
  const navigate = useNavigate();
  const { id } = useParams();

  const backToQuickView = () => {
    navigate('/home');
  };

  return (
    <div className={`${classes.root} ${className}`}>
      <div className={classes.header}>
        <TabHeader />

        {id && (
          <div className={classes.widgetsDiv}>
            <DashboardWidgets
              className={classes.widgets}
              clickable={false}
              locationId={id}
            />
          </div>
        )}

        <div className={classes.backIconWrapper}>
          <IconButton edge="end" onClick={backToQuickView}>
            <Close fontSize="medium" />
          </IconButton>
        </div>
      </div>

      <TabsNav disabled={disabled}>{children}</TabsNav>
    </div>
  );
}
